import { useState } from 'react'

import { addFavoritePattern, removeFavoritePattern } from '../api/secureRequests'
import { useAuth } from '../context/AuthContext'
import { useUserRelations } from '../context/UserRelationsContext'

export const useFavoritePattern = (patternId: string) => {
  const [loading, setLoading] = useState(false)
  const [showLoginModal, setShowLoginModal] = useState(false)
  const { idToken } = useAuth()
  const { isFavorited, addFavorite, removeFavorite } = useUserRelations()

  const favorited = isFavorited(patternId)

  const handleFavoriteClick = async (e?: React.MouseEvent) => {
    if (e) e.stopPropagation()

    if (!idToken) {
      setShowLoginModal(true)
      return
    }

    // Optimistic update
    const wasAlreadyFavorited = favorited
    if (!wasAlreadyFavorited) {
      addFavorite(patternId)
    } else {
      removeFavorite(patternId)
    }

    setLoading(true)
    try {
      if (!wasAlreadyFavorited) {
        await addFavoritePattern(patternId, idToken)
      } else {
        await removeFavoritePattern(patternId, idToken)
      }
    } catch (err: unknown) {
      // Rollback on failure
      if (!wasAlreadyFavorited) {
        removeFavorite(patternId)
      } else {
        addFavorite(patternId)
      }
      console.error('Failed to update favorite:', err)
    } finally {
      setLoading(false)
    }
  }

  return {
    favorited,
    loading,
    showLoginModal,
    setShowLoginModal,
    handleFavoriteClick,
  }
}
